import React, { useMemo, useState } from "react"
import { TCLabel } from "../Label/TopCourtLabel"
import { Grid, TextField, TextareaAutosize } from "@mui/material"
import Creatable, { useCreatable } from 'react-select/creatable';
import Select from 'react-select';
// import React, { useState } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

function TCInput({
  styles,
  label,
  disabled = false,
  value,
  defaultValue,
  type,
  rows,
  maxRows,
  fullWidth = true,
  placeHolder = "",
  onChange,
  onBlur,
  onInput,
  showInfo,
  showAlert,
  autoFocus = false,
  inputProps,
  enterAction,
  isThousandSeparator = false,
}) {

  const InputProps = {
    ...inputProps
    // inputProps: { min: "2020-05-01", max: "2020-05-04"} 
  }

  if (isThousandSeparator) {
    InputProps.inputProps = {
      ...InputProps.inputProps,
      onInput: (e) => {
        let value = e.target.value.replace(/[^,\d]/g, '').replace(',', '.');

        e.target.value = value.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
      }
    };
  }

  return (
    <>
      <Grid container alignItems={'flex-end'} spacing={1}>
        <Grid item>
          <TCLabel style={{ fontSize: 13 }}>{label}</TCLabel>
        </Grid>
        <Grid item sx={{ pt: '0px !important', pl: '2px !important' }}>
          {showAlert && <TCLabel style={{ fontSize: 11, color: '#f44336' }}>{showAlert}</TCLabel>}
        </Grid>
      </Grid>
      <TextField placeholder={placeHolder} fullWidth={fullWidth} multiline={type == "textarea"}
        type={type} rows={rows} maxRows={maxRows} onInput={onInput}
        disabled={disabled} value={value} defaultValue={defaultValue}
        onKeyDown={(e) => {
          if (type === 'number' && e.code === 'Minus') {
            e.preventDefault();
          }
          if (e.key == 'Enter') {
            if (enterAction) {
              enterAction()
            }
          }
        }}
        onChange={onChange}
        onBlur={onBlur}
        sx={{ ...TCInputStyle, ...styles }}
        {...InputProps}
      />
      {showInfo && <TCLabel style={{ fontSize: 11, color: '#1e88e5' }}>{showInfo}</TCLabel>}
    </>
  )
}

function TCTextArea({
  styles,
  label,
  disabled = false,
  value,
  defaultValue,
  type,
  rows,
  maxRows,
  fullWidth = true,
  placeHolder = "",
  onChange,
  showInfo,
  showAlert
}) {
  return (
    <>
      <Grid container alignItems={'flex-end'} spacing={1}>
        <Grid item>
          <TCLabel style={{ fontSize: 13, color: "rgb(133, 133, 133)" }}>{label}</TCLabel>
        </Grid>
        <Grid item sx={{ pt: '0px !important', pl: '2px !important' }}>
          {showAlert && <TCLabel style={{ fontSize: 11, color: '#f44336' }}>{showAlert}</TCLabel>}
        </Grid>
      </Grid>
      <TextareaAutosize placeholder={placeHolder} fullWidth={fullWidth} multiline={type == "textarea"}
        type={type} rows={rows} maxRows={maxRows}
        disabled={disabled} value={value} defaultValue={defaultValue}
        onChange={onChange}
        style={{ ...TCInputStyle, ...styles }}
      />
      {showInfo && <TCLabel style={{ fontSize: 11, color: '#1e88e5' }}>{showInfo}</TCLabel>}
    </>
  )
}

function TCSelect({
  styles,
  label,
  disabled = false,
  value,
  defaultValue,
  type,
  rows,
  maxRows,
  fullWidth = true,
  placeHolder,
  onChange,
  options = [],
  showAlert = null,
  showInfo = null,
  isMulti = false,
  inDialog = false,
  isClearable,
  isSearchable = true
}) {
  const portalTarget = useMemo(
    () => (typeof window !== 'undefined' ? document.body : null),
    []
  );
  return (
    <>
      {/* <TCLabel style={{fontSize: 13}}>{label}</TCLabel> */}
      <Grid container alig alignItems={'flex-end'} spacing={1}>
        <Grid item>
          <TCLabel style={{ fontSize: 13, color: "rgb(133, 133, 133)" }}>{label}</TCLabel>
        </Grid>
        <Grid item sx={{ pt: '0px !important', pl: '2px !important' }}>
          {showAlert && <TCLabel style={{ fontSize: 11, color: '#f44336' }}>{showAlert}</TCLabel>}
        </Grid>
      </Grid>
      <Select
        classNamePrefix="rs"
        menuPortalTarget={inDialog ? document.querySelector('.MuiDialog-root') : portalTarget}
        placeholder={placeHolder}
        options={options}
        value={value}
        defaultValue={defaultValue}
        isMulti={isMulti}
        styles={{
          menuPortal: base => ({ ...base, zIndex: 9999 }),
          ...TCSelectStyle,
          ...styles,
        }}
        isDisabled={disabled}
        onChange={onChange}
        isClearable={isClearable}
        isSearchable={isSearchable}
        menuPosition="fixed"
      />
      {showInfo && <TCLabel style={{ fontSize: 11, color: '#1e88e5' }}>{showInfo}</TCLabel>}
    </>
  )
}

function TCCreatableSelect({
  styles,
  label,
  disabled = false,
  value,
  defaultValue,
  type,
  rows,
  maxRows,
  fullWidth = true,
  placeHolder,
  onChange,
  options = [],
  showAlert = null,
  showInfo = null,
  isMulti = false,
  inDialog = false,
}) {
  return (
    <>
      <Grid container alig alignItems={'flex-end'} spacing={1}>
        <Grid item>
          <TCLabel style={{ fontSize: 13, color: "rgb(133, 133, 133)" }}>{label}</TCLabel>
        </Grid>
        <Grid item sx={{ pt: '0px !important', pl: '2px !important' }}>
          {showAlert && <TCLabel style={{ fontSize: 11, color: '#f44336' }}>{showAlert}</TCLabel>}
        </Grid>
      </Grid>
      <Creatable
        menuPortalTarget={inDialog ? document.querySelector('.MuiDialog-root') : document.body}
        placeholder={placeHolder}
        options={options}
        value={value}
        defaultValue={defaultValue}
        isMulti={isMulti}
        styles={{
          menuPortal: base => ({ ...base, zIndex: 9999 }),
          ...TCCreatableSelectStyle,
          ...styles,
        }}
        isDisabled={disabled}
        onChange={onChange}
      />
      {showInfo && <TCLabel style={{ fontSize: 11, color: '#1e88e5' }}>{showInfo}</TCLabel>}
    </>
  )
}

const TCInputWithToggle = (props) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => {
    setShowPassword((prev) => !prev);
  }

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  }

  const inputType = showPassword ? 'text' : 'password';

  const endAdornment = (
    <InputAdornment position="end">
      <IconButton
        aria-label="toggle password visibility"
        onClick={handleClickShowPassword}
        onMouseDown={handleMouseDownPassword}
        edge="end"
        sx={{ color: '#808080' }}
      >
        {showPassword ? <VisibilityOff /> : <Visibility />}
      </IconButton>
    </InputAdornment>
  )

  const newInputProps = {
    ...props.inputProps,
    InputProps: {
      ...props.inputProps?.InputProps,
      endAdornment: endAdornment,
    },
  }

  return (
    <TCInput
      {...props}
      type={inputType}
      inputProps={newInputProps}
    />
  )
}

export const TCCreatableSelectStyle = {
  control: (baseStyles, { isDisabled }) => ({
    ...baseStyles,
    // borderColor: "#344767",
    fontSize: '13px',
    border: '0.5px solid #2196f366',
    // backgroundColor: '#f8fafc',
    borderColor: "#2196f3",
    backgroundColor: isDisabled ? "#f5f5f5" : "#ffffff",
    borderRadius: 8,
    "&:hover": {
      borderColor: "#2196f3"
    },
  }),
  option: (base) => ({
    ...base,
    fontSize: '13px',
    height: '100%',
  }),
  menuPortal: base => ({
    ...base,
    zIndex: 9999,
    fontSize: '13px'
  }),
  menuList: (base) => ({
    ...base,
    fontSize: '13px',
  })
}

export const TCSelectStyle = {
  control: (baseStyles, { isDisabled }) => ({
    ...baseStyles,
    // borderColor: "#344767",
    fontSize: '13px',
    border: '0.5px solid #2196f366',
    // backgroundColor: '#f8fafc',
    borderColor: "#2196f3",
    backgroundColor: isDisabled ? "#f5f5f5" : "#ffffff",
    borderRadius: 8,
    "&:hover": {
      borderColor: "#2196f3"
    },
  }),
  option: (base) => ({
    ...base,
    fontSize: '13px',
    height: '100%',
  }),
  menuPortal: base => ({
    ...base,
    fontSize: '13px'
  }),
  menuList: (base) => ({
    ...base,
    fontSize: '13px',
  })
}

export const TCTextAreaStyle = {
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor: "#2196f3", // #d8f0e9 #64a591
    },
    "&:hover fieldset": {
      borderColor: '#2196f3',
    },
    "&.Mui-disabled input": {
      backgroundColor: "#f5f5f5"
    }
  },
  textarea: {
    border: "none",
    margin: 0,
    padding: 1,
    borderRadius: 2,
    borderColor: "#64a591",
    backgroundColor: "#ffffff",
    fontWeight: 10
  },
  "& fieldset": { border: '0.5px solid #2196f366', borderRadius: 2, },
}

export const TCInputStyle = {
  "& .MuiOutlinedInput-root": {
    "&.Mui-focused fieldset": {
      borderColor: "#2196f3", // #d8f0e9 #64a591
    },
    "&:hover fieldset": {
      borderColor: '#2196f3',
    },
    "&.Mui-disabled input": {
      backgroundColor: "#f5f5f5"
    }
  },
  input: {
    border: "none",
    margin: 0,
    padding: 1,
    borderRadius: 2,
    borderColor: "#64a591",
    // backgroundColor: "#f5f5f5",
    backgroundColor: "#ffffff",
    // backgroundColor: '#d8f0e9',
    fontWeight: 10
  },
  textarea: {
    backgroundColor: "#ffffff",
    fontWeight: 10,
    margin: 0,
    padding: 1,
  },
  "& fieldset": { border: '0.5px solid #2196f366', borderRadius: 2, },
  "& input[type='date']": {
    // padding: '8px 12px',
    textAlign: 'left',
    // fontWeight: 400,
    backgroundColor: "#ffffff",
    // appearance: "none",
    // WebkitAppearance: "none",
    textAlignLast: "left",
  }
}

export { TCInput, TCSelect, TCTextArea, TCCreatableSelect, TCInputWithToggle }